/**
 * FeaturesSection — eyebrow + heading + 3 feature cards.
 * Path: features.{eyebrow, heading, items[0..2].{title, body}}
 */

import { BilingualTextField, BilingualTextareaField, SectionPanel } from '../fields/BilingualFields'

export default function FeaturesSection({ getField, setField }) {
  return (
    <SectionPanel title="Features" subtitle="How businesses use OVACS — 3-item card grid">
      <BilingualTextField label="Eyebrow" path="features.eyebrow" getField={getField} setField={setField} />
      <BilingualTextField label="Section heading" path="features.heading" getField={getField} setField={setField} />

      <hr className="my-3 border-gray-200" />
      {[0, 1, 2].map((i) => (
        <div key={i} className="bg-gray-50 rounded-lg p-4 border border-gray-200 mb-3">
          <h4 className="text-sm font-semibold text-gray-700 mb-2">Feature {i + 1}</h4>
          <BilingualTextField label="Title" path={`features.items.${i}.title`} getField={getField} setField={setField} />
          <BilingualTextareaField label="Body" path={`features.items.${i}.body`} getField={getField} setField={setField} rows={3} />
        </div>
      ))}
    </SectionPanel>
  )
}
